import {API_URL} from "../middleware/api";


const createQueryString = (data) => {
    const buildQuery = (obj, prefix = "") => {
        return Object.keys(obj)
            .map((key) => {
                const value = obj[key];
                const prefixedKey = prefix ? `${prefix}[${key}]` : key;

                if (value !== null && typeof value === "object" && !Array.isArray(value)) {
                    return buildQuery(value, prefixedKey);
                }
                if (Array.isArray(value)) {
                    return value.map((val) => `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(val)}`).join("&");
                }
                return `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`;
            })
            .join("&");
    };

    return buildQuery(data);
};

/**
 * Download file from url with JWT token
 * @param url
 * @param filename
 * @param query
 * @return {Promise<void>}
 */
export const downloadFile = async (url, filename, query = {}) => {
    // prepare url with api prefix
    const preparedUrl = url.startsWith("/api/v1/") ? `${API_URL}${url.replace("/api/v1/", "")}` : url;

    // get JWT token from local storage
    const jwt = localStorage.getItem("access_token");
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${jwt}`);
    const response = await fetch(`${preparedUrl}?${createQueryString(query)}`, {
        method: 'GET',
        headers: headers,
    });
    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);
    const a = document.createElement
    ('a');
    a.href = urlBlob;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(urlBlob);
    document.body.removeChild(a);
}